import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Icon from "../icon";
export default function Award(props) {
    return (_jsxs(Icon, { ...props, children: [_jsx("path", { d: "M12 2a6 6 0 1 0 0 12 6 6 0 0 0 0-12ZM4 8a8 8 0 1 1 16 0A8 8 0 0 1 4 8Z" }), _jsx("path", { d: "M15.66 12.89a1 1 0 0 1 1.12.86L18 22.87a1 1 0 0 1-1.5.99L12 21.16l-4.49 2.7a1 1 0 0 1-1.5-1l1.2-9.1a1 1 0 0 1 2 .26l-.95 7.06 3.23-1.94a1 1 0 0 1 1.02 0l3.23 1.94L14.8 14a1 1 0 0 1 .86-1.12Z" })] }));
}
